import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.scss';
import App from './App';
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import BlogHomePage from "./blogs/BlogHomePage";
import HomeRoute from "./components/HomeRoute";
import Resume from "./components/Resume";
import { HelmetProvider } from "react-helmet-async";
import AgenticArchitecture from "./blogs/AgenticArchitecture";
import InformationTheory from "./blogs/InformationTheory";
import AutonomyArchitecture from "./blogs/AutonomyArchitecture";
import JavaRenaissance from "./blogs/JavaRenaissance";
import Projects from "./components/Projects";
import AGIInvention from "./blogs/AGI-Invention";
import NotFound from "./components/NotFound";


// function NotFoundRedirect() {
//     React.useEffect(() => {
//         window.location.replace("/404.html");
//     }, []);
//
//     return null;
// }


if ("scrollRestoration" in window.history) {
    window.history.scrollRestoration = "manual";
}

const router = createBrowserRouter([
    {
        path: '/',
        element: <App />,
        children: [
            { index: true, element: <HomeRoute /> },
            {
                path: 'blog',
                children: [
                    { index: true, element: <BlogHomePage /> },
                    { path: 'agentic-architecture', element: <AgenticArchitecture /> },
                    { path: 'information-theory', element: <InformationTheory /> },
                    { path: 'autonomy-architecture', element: <AutonomyArchitecture /> },
                    { path: 'java-renaissance', element: <JavaRenaissance /> },
                    { path: 'agi-invention', element: <AGIInvention /> },
                ],
            },
            { path: "*", element: <NotFound /> },
        ],
    },

    { path: "/resume", element: <Resume /> },
    { path: "/projects", element: <Projects /> },

    // MUST BE LAST

]);


const container = document.getElementById('root') as HTMLElement;

if (container.hasChildNodes()) {
    ReactDOM.hydrateRoot(
        container,
        <React.StrictMode>
            <HelmetProvider>
                <RouterProvider router={router} />
            </HelmetProvider>
        </React.StrictMode>
    );
} else {
    const root = ReactDOM.createRoot(container);

    root.render(
        <React.StrictMode>
            <HelmetProvider>
                <RouterProvider router={router} />
            </HelmetProvider>
        </React.StrictMode>
    );
}